import styled from "styled-components"

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 1.3rem;
  margin-right: 1rem;
  align-items: center;
`
